module.exports = __webpack_public_path__ + "img/SOLERAS.adaab352.jpg";